import { gql } from '@apollo/client';

export const fetchOrderDetailForTransactionAccount = gql`
  query fetchOrderDetailForTransactionAccount(
    $transactionAccountId: ID!
    $searchOptions: ConnectionSearchOptions
    $filterOptions: [FilterOption]
    $fetchIsExternallyBilled: Boolean = false
  ) {
    transactionAccount(id: $transactionAccountId) {
      id
      orders(searchOptions: $searchOptions, filterOptions: $filterOptions) {
        totalCount
        nodes {
          id
          orderNumber
          billingContactEmail
          created
          contextSubject
          contextSubjectId
          billTo {
            billToCompanyName
            billToAccountId
            billToCity
            billToAddress1
            billToAddress2
            billToCountry
            billToState
            billToPostalCode
          }
          currency
          shipTo {
            shipToCompanyName
            shipToAccountId
            shipToCity
            shipToAddress1
            shipToAddress2
            shipToCountry
            shipToState
            shipToPostalCode
          }
          authorProfile {
            name
            email
            picture
          }
          invoiceGroup {
            id
            name
            currency
            shipToParty {
              name
            }
            purchaseOrder {
              number
            }
          }
          sourceSystem
          purchaseOrderNumber
          metadata {
            supportTicketNumber
          }
          metadataObj {
            supportTicketNumber
            handNote
            termsOfTransfer
            reasonCode
            newBillingAdmin
            currentBillingAdmin
            contractId @include(if: $fetchIsExternallyBilled)
            contractType @include(if: $fetchIsExternallyBilled)
          }
          orderLineItems {
            nodes {
              lineItemId
              quantity
              type
              skipTrial
              promotions {
                id
                title
                status
                type
                promotionCode
                benefits {
                  subBenefitType
                  value
                  values {
                    appliedOn
                    value
                  }
                  iterations
                  duration
                  benefitType
                }
                promotionWindow {
                  endTime
                  startTime
                }
              }
              offering {
                id
                name
              }
              pricingPlan {
                id
                type
                billingFrequency
              }
              orderTransitionType
              salesTransitionType
              edition
              entitlementId
              entitlementNumber
              parentEntitlementId
              productName
              productId
              orderLineItemsPurchaseMetadata {
                fieldName
                fieldValue
              }
              orderLineItemsAccountModification {
                accountModificationTransactionAccountId
                accountModificationInvoiceGroupId
              }
              isExternallyBilled @include(if: $fetchIsExternallyBilled)
            }
          }
        }
      }
    }
  }
`;
